// extracted by mini-css-extract-plugin
export default {"main":"hz-layouts-auth-layout-components-global-layout-wrap-index-main"};